import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getDigiKycInitUrl } from "../utils/urlHelper";

const digiKycInitDataApi = createApi({
  reducerPath: "digiKycInit",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    digiKycInit: builder.mutation({
      query: (body) => ({
        url: getDigiKycInitUrl(),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useDigiKycInitMutation } = digiKycInitDataApi;
export { digiKycInitDataApi };
